// extracted by mini-css-extract-plugin
module.exports = {"container":"bubblewrap_container__3AaCT"};